// routes
import { PATH_DASHBOARD } from '../../../routes/paths'
import SvgIconStyle from '../../../components/SvgIconStyle'
import { ORGANIZER_APP_URL } from 'constants/index'

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
)

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  diamond: getIcon('ic_diamond'),
  menuItem: getIcon('ic_menu_item'),
  upload: getIcon('ic_upload'),
  components: getIcon('ic_components'),
  elements: getIcon('ic_elements'),
  carousel: getIcon('ic_carousel'),
  animate: getIcon('ic_animate'),
  authenticator: getIcon('ic_authenticator'),
  ticket: getIcon('ic_ticket'),
  groups: getIcon('ic_groups'),
  verified: getIcon('ic_verified'),
  sendToMobile: getIcon('ic_send_to_mobile'),
}

// Annotated rather than inferred: `children` is optional and no entry uses it
// today, so an inferred type drops the property entirely and every consumer that
// walks sub-items (filterNavByPermissions, menuRoleMapping, the NavSection
// components) stops type-checking.
export interface NavItem {
  title: string
  path: string
  icon?: JSX.Element
  html_id?: string
  children?: { title: string; path: string; html_id?: string }[]
}

export interface NavGroup {
  subheader: string
  items: NavItem[]
}

// Coin Transfer, Subscription, Promoter and Community are deliberately absent:
// the features are retired, so their entries are removed rather than
// permission-gated. Their routes answer 404 via RETIRED_ROUTES in
// helpers/access.
const navConfig: NavGroup[] = [
  // CREATOR CENTER
  // ----------------------------------------------------------------------
  {
    subheader: 'key_creator_center',
    items: [
      {
        title: 'key_dashboard',
        path: PATH_DASHBOARD.creator_center.dashboard,
        icon: ICONS.dashboard,
      },
      {
        title: 'Summary',
        path: PATH_DASHBOARD.creator_center.summary,
        icon: ICONS.invoice,
      },
      {
        title: 'key_myproduct',
        path: PATH_DASHBOARD.creator_center.my_content,
        icon: ICONS.components,
      },
      {
        title: 'Event Check-in',
        path: `${ORGANIZER_APP_URL}/organization`,
        html_id: 'b-navigation-ticketing-checkin',
        icon: ICONS.ticket,
      },
      {
        title: 'key_sales',
        path: PATH_DASHBOARD.creator_center.revenue,
        icon: ICONS.analytics,
      },
    ],
  },
  // TEAM
  // ----------------------------------------------------------------------
  {
    subheader: 'key_team',
    items: [
      {
        title: 'key_team_management',
        path: PATH_DASHBOARD.creator_center.team,
        html_id: 'b-navigation-team-management',
        icon: ICONS.groups,
      },
    ],
  },
  // Promotion
  {
    subheader: 'Promotion',
    items: [
      {
        title: 'key_my_voucher',
        path: PATH_DASHBOARD.promotion.voucher,
        icon: ICONS.ticket,
        html_id: 'b-navigation-voucher',
      },
    ],
  },
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'key_general',
    items: [
      {
        title: 'key_mybalance',
        path: PATH_DASHBOARD.general.balance.root,
        icon: ICONS.animate,
      },
      {
        title: 'key_data_verification',
        path: PATH_DASHBOARD.general.verification.root,
        icon: ICONS.verified,
      },
    ],
  },
]

export default navConfig
